<template>
  <div class="wrap">
    <div class="header">
      <div class="tab">
        <div
          class="tab-item"
          v-for="(item, index) in tabContent"
          :key="index"
          :class="{ active: activeIndex == index }"
          @click="tabChange(index)"
        >
          {{ item }}
          <div style="width: 100%; text-align: center">
            <div
              class="tab-line"
              v-show="activeIndex == index"
              :class="{ w90: index == 2 }"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div class="content" ref="content">
      <PolicySummary v-if="activeIndex == 0" />
      <ClaimSummary v-if="activeIndex == 1" />
      <ServiceNetSummary v-if="activeIndex == 2" />
    </div>
    <div class="loading" v-show="$store.state.showLoading">
      <img :src="loadingImgPath" alt="" />
    </div>
  </div>
</template>

<script>
import PolicySummary from "./components/policySummary";
import ClaimSummary from "./components/claimSummary";
import ServiceNetSummary from "./components/serviceNetSummary";
export default {
  components: {
    PolicySummary,
    ClaimSummary,
    ServiceNetSummary,
  },
  data() {
    return {
      loadingImgPath:
        "https://open.zking.com/r/cms/internet-static/zki-agent-applet/images/ZKI-load_1218.gif",
      tabContent: ["保费概况", "赔付状况", "服务网络概况"],
      activeIndex: 0,
      showLoading: false,
    };
  },
  methods: {
    tabChange(index) {
      this.activeIndex = index;
      let item1 = this.tabContent[index];
      this.$refs.content.scrollTop = 0;
      this.$set(this.tabContent, index, item1);
      this.$store.commit("changeActiveIndex", index);
    },
    getUrl() {
      let url = window.location.href;
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(url.indexOf("?") + 1);
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
        }
      }
      return theRequest;
    },
  },
  created() {
    let request = this.getUrl();
    if (JSON.stringify(request) !== "{}") {
      let apptoken = request["token"];
      localStorage.setItem("token1", apptoken);
    } else {
      localStorage.removeItem("token1");
    }
  },
  mounted() {
    if (this.$route.query.serviceStation == 2) {
      let that = this;
      setTimeout(function () {
        that.activeIndex = 2;
      }, 1000);
    }
  },
};
</script>

<style>
html,
body,
#app {
  height: 100%;
}
</style>
<style scoped>
* {
  box-sizing: border-box;
}
.wrap {
  width: 100%;
  height: 100%;
  font-size: 0.16rem;
  display: flex;
  flex-direction: column;
}

.header {
  width: 100%;
  height: 0.5rem;
  background: #fff;
}

.tab {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 0 0.18rem;
}

.tab-item {
  width: 100%;
  height: 100%;
  text-align: left;
  line-height: 0.5rem;
  font-size: 0.15rem;
  color: #999;
  position: relative;
}

.tab-line {
  width: 50%;
  height: 0.03rem;
  background: #31d493;
  margin-left: 0.05rem;
}

.active {
  color: #333;
  font-size: 0.18rem;
  font-weight: bold;
}

.content {
  width: 100%;
  height: auto;
  background: #f7f6f9;
  padding: 0.15rem 0.18rem;
  -webkit-overflow-scrolling: touch;
  flex: 1;
  overflow: scroll;
  overflow-x: hidden;
}

.w90 {
  width: 90%;
}

.loading {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: #000;
  opacity: 0.6;
  z-index: 999;
}

.loading img {
  width: 120px;
  height: 60px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>


// WEBPACK FOOTER //
// src/pages/operationSummary/operationSummary.vue